<div class="dialogContainer">
  <div class="header">
    <h2>Processing Status</h2>
  </div>
  <div class="content">
    <table mat-table [dataSource]="statusRecords" matSort class="paginatedTable bordered-table">
      <ng-container matColumnDef="entityId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
        <td mat-cell *matCellDef="let record">{{ record.entityId }}</td>
      </ng-container>
      <ng-container matColumnDef="entityRevision">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Revision</th>
        <td mat-cell *matCellDef="let record">{{ record.entityRevision }}</td>
      </ng-container>
      <ng-container matColumnDef="productFamily">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Family</th>
        <td mat-cell *matCellDef="let record">{{ record.productFamily }}</td>
      </ng-container>
      <ng-container matColumnDef="erpStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let record">{{ record.erpStatus }}</td>
      </ng-container>
      <ng-container matColumnDef="requestedShipDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Requested Ship</th>
        <td class="centered-cell" mat-cell *matCellDef="let record">{{ record.requestedShipDate }}</td>
      </ng-container>
      <ng-container matColumnDef="requestedEngineeringDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Requested Engineering</th>
        <td class="centered-cell" mat-cell *matCellDef="let record">{{ record.requestedEngineeringDate }}</td>
      </ng-container>
      <ng-container matColumnDef="promisedEngineeringDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Engineering Promised</th>
        <td class="centered-cell" mat-cell *matCellDef="let record">{{ record.promisedEngineeringDate }}</td>
      </ng-container>
      <ng-container matColumnDef="scheduledShipDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Scheduled Ship</th>
        <td class="centered-cell" mat-cell *matCellDef="let record">{{ record.scheduledShipDate }}</td>
      </ng-container>
      <ng-container matColumnDef="erpOrderNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Order Number</th>
        <td mat-cell *matCellDef="let record">{{ record.erpOrderNumber }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
  <div mat-dialog-actions>
    <span class="spacer"></span>
    <span>
      <button matButton="elevated" (click)="close()">Close</button>
    </span>
  </div>
</div>
